import { Checkbox, type CheckboxProps, FormControlLabel } from '@mui/material';
import { type Control, Controller, type FieldValues, type Path, type RegisterOptions } from 'react-hook-form';

type FormCheckboxFieldProps<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  control: Control<TFieldValues>;
  rules?: RegisterOptions<TFieldValues, Path<TFieldValues>>;
  label: React.ReactNode;
  onBeforeChange?: (checked: boolean) => boolean | void;
} & Omit<CheckboxProps, 'name' | 'defaultValue' | 'value' | 'onChange' | 'inputRef'>;

export function FormCheckboxField<TFieldValues extends FieldValues>(props: FormCheckboxFieldProps<TFieldValues>) {
  const { name, control, rules, label, onBeforeChange, ...checkBoxProps } = props;

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => {
        const handleChange = onBeforeChange
          ? (e: React.ChangeEvent<HTMLInputElement>) => {
              const result = onBeforeChange(e.target.checked);
              if (result !== false) {
                field.onChange(e);
              }
            }
          : field.onChange;

        return (
          <FormControlLabel
            label={label}
            control={<Checkbox {...field} {...checkBoxProps} checked={!!field.value} onChange={handleChange} />}
          />
        );
      }}
    />
  );
}
